import { assign } from 'lodash';
import createReducer from './baseReducer';

const conditions = {
  RECEIVE_ADD_COMPANY: (state, data, error) => {
    if (state.filtered) {
      return assign({}, state, {
        error,
        isFetching: false,
        didInvalidate: error !== false,
      });
    }
    return false;
  },
};

export default createReducer('companies', 'company', 'companies', conditions);
